@if (vm$ | async; as vm) {
  @if (!vm.hasCalculation) {
  <p class="bpx-empty bpx-empty--page" i18n>Run a calculation to view rerun samples.</p>
  } @else {
  <div class="bpx-detail">
    <div class="bpx-detail__item">
      <span class="bpx-detail__label" i18n>Rerun Samples</span>
      <span class="bpx-detail__value" id="rerun-samples">{{ vm.summary.rerunSamples }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label" i18n>Assay Results Affected</span>
      <span class="bpx-detail__value" id="rerun-assay-results">{{ vm.summary.assayResultsAffected }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label" i18n>Replicates</span>
      <span class="bpx-detail__value" id="rerun-replicates">{{ vm.summary.replicates }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label" i18n>Discarded</span>
      <span class="bpx-detail__value" id="rerun-discarded">{{ vm.summary.discarded }}</span>
    </div>
  </div>

  <section class="bpx-section rerun-section">
    <div class="bpx-section__head">
      <h3 class="bpx-section__title" i18n>Rerun Sample Replicates</h3>
    </div>

    <app-shared-table [sharedTableContent]="vm.tableContent"
      [customCssClassBinding]="customCssClassBinding"
      [dropdownFilterKeys]="dropdownFilterKeys"
      [csvExportDisabled]="(isStudySaved$ | async) !== true"></app-shared-table>

    @if (!vm.summary.replicates) {
    <p class="bpx-empty" i18n>No rerun samples were detected for the current calculation.</p>
    }
  </section>
  }
}
